export const expectedResponseKeys = [
  'autoOrdering',
  'designerEnabled',
  'features',
  'globalJsUrl',
  'guideCssUrl',
  'guideWidget',
  'guides',
  'lastGuideStepSeen',
  'normalizedUrl',
  'preventCodeInjection',
  'segmentFlags',
  'throttling',
  'props',
  'type',
  'children',
  'latestDismissedAutoAt',
]
